var map = {
	"./image1.png": 32702,
	"./image2.png": 18453,
	"./image3.png": 82540,
	"./image4.png": 42435,
	"./image5.png": 94682,
	"./image6.png": 15793,
	"./image7.png": 5576,
	"./image8.png": 35423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73670;